module.exports = __webpack_public_path__ + "img/extended.4612ed24.png";